import React from "react";
import "./salarySacrificeModal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
const SalarySacrificeModal = (props) => {
  return (
    <div className="salary-sacrifice-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">{props.headTitle}</div>
      <div className="sub-text">
        <p>{props.description}</p>
        <p>{props.subDescription}</p>
        <p>{props.subDescription1}</p>
        <p>
          <Buttons
            className="tertiary"
            name={props.btnLinkName}
            handleClick={props.handleOpenUrl}
          />
        </p>
      </div>
      <div className="text-end mt-5">
        {props.btnCloseName === "Close" ? (
          <Buttons
            className="secondary"
            name={props.btnCloseName}
            handleClick={props.handleCloseButton}
          />
        ) : (
          <>
            <Buttons
              className="secondary me-4"
              name={props.btnCancelName}
              handleClick={props.handleCloseButton}
            />
            <Buttons
              className="primary"
              name={props.btnSendName}
              handleClick={props.handleCloseButton}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SalarySacrificeModal;
